/* ===============================================================================
   BAMBOOVE — KHỐI "MATERIAL SHOWCASE": hiệu ứng HIỆN DẦN 1 LẦN khi cuộn tới
   -------------------------------------------------------------------------------
   • Bám đúng JS của bản thiết kế `v53`: IntersectionObserver, ngưỡng 0.15,
     rootMargin '0px 0px -40px 0px', thêm lớp `is-in` rồi NGỪNG theo dõi.
   • Không có IntersectionObserver HOẶC người dùng bật "giảm chuyển động"
     => hiện ngay, KHÔNG hiệu ứng.
   • Chạy lại được trong Trình soạn theme (shopify:section:load).
   =============================================================================== */
(function () {
  function hienDan(root) {
    var pham = root || document;
    var targets = pham.querySelectorAll('.bamboove-ms [data-bb-fade]');
    if (!targets.length) return;

    var giamChuyenDong =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || giamChuyenDong) {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    Array.prototype.forEach.call(targets, function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hienDan(document); });
  } else {
    hienDan(document);
  }

  // Trình soạn theme: nạp lại khối nào thì chạy lại cho khối đó
  document.addEventListener('shopify:section:load', function (e) {
    hienDan(e.target);
  });
})();
